import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApplicationConfigService } from './application-config.service';
import { ILLEGAL_INVOCATION } from '../app/shared/util/security-util';
import { RefAdrService } from './ref-adr.service';
import { IRefAdr } from '../models/ref-adr.model';
import { createRequestOption } from '../app/shared/util/request-util';
import { map } from 'rxjs/operators';
import { ApiProviderService } from './api-provider.service';

export type EntityResponseType = HttpResponse<IRefAdr>;
export type EntityArrayResponseType = HttpResponse<IRefAdr[]>;

@Injectable({ providedIn: 'root' })
export class RefAdrExtendedService extends RefAdrService {
  protected resourceUNUrl = API_ENDPOINTS.REF_ADR_UN;
  protected endPoint = API_ENDPOINTS.REF_ADR;

  constructor(protected apiProvider: ApiProviderService, protected override http: HttpClient, protected override applicationConfigService: ApplicationConfigService) {
    super(http, applicationConfigService);
  }

  override create(): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override update(): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override partialUpdate(): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override find(): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  queryUNCode(): Observable<HttpResponse<number[]>> {
    const options = createRequestOption();
    return this.apiProvider.publicGet<number[]>(this.resourceUNUrl, { params: options, observe: 'response' });
  }

  override query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.apiProvider
      .publicGet<IRefAdr[]>(this.endPoint, { params: options, observe: 'response' })
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  override delete(): Observable<HttpResponse<{}>> {
    throw ILLEGAL_INVOCATION;
  }
}
